import React from "react";
import ObsIframe from "../../iframe-component/onboarding/ObsIframe";

const ServiceIntegrator = () => {
  return <ObsIframe path="/serviecIntegrator" />;
};

export default React.memo(ServiceIntegrator);
